import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./styles/global.css";

import RootLayout from "./components/RootLayout/RootLayout";
import Home from "./pages/home/HomePage";
import ServicePage from "./pages/services/ServicesPage";
import RequestServicePage from "./pages/requested-service/RequestedServicePage";
import ProvidersPage from "./pages/providers/ProvidersPage";
import AboutPage from "./pages/about/AboutPage";
import ContactPage from "./pages/contact/ContactPage";
import ContactOptionsPage from "./pages/contact-option/ContactOptionsPage";
import PrivacyPolicyPage from "./pages/privacy-policy/PrivacyPolicyPage";
import NotFoundPage from "./pages/not-found/NotFoundPage";
import { CategoryProvider } from "./context/CategoryContext";

const route = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/solicita-serviciu",
        element: <ServicePage />,
      },
      {
        path: "/:city/solicita-serviciu",
        element: <ServicePage />,
      },
      {
        path: "/devino-prestator",
        element: <ProvidersPage />,
      },
      {
        path: "/despre",
        element: <AboutPage />,
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "/politica-confidentialitate",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "/:city/:categorySlug",
        element: <ContactOptionsPage />,
      },
      {
        path: "/solicita-serviciu/:city/:categorySlug?/formular",
        element: <RequestServicePage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

function App({ categoryData }) {
  // Get initial data from SSR if available
  const initialData =
    categoryData ||
    (typeof window !== "undefined" && window.__INITIAL_DATA__) ||
    null;

  return (
    <CategoryProvider initialData={initialData}>
      <RouterProvider router={route} />
    </CategoryProvider>
  );
}

export default App;
